import {Client} from "../../types/userManagement";
import {AutoCheckInConfig} from "./types";
import {useMemo} from "react";

export function useGetHeader(client: Client | undefined, profile: AutoCheckInConfig | undefined): string {

    return useMemo(() => {
        if(!client){
            return "No Client Selected"
        }

        if (!profile){
            return "No Profile Selected"
        }

        return `Editing Profile (${profile.name})`
    },[client, profile])


}